import React from 'react';
import { motion } from 'framer-motion';
import './Reviews.css';

const Reviews = () => {
    const reviewVariants = {
        hidden: (direction) => ({
            x: direction < 0 ? -100 : 100,
            opacity: 0
        }),
        visible: {
            x: 0,
            opacity: 1,
            transition: {
                x: { type: "spring", stiffness: 100, damping: 20 }, 
                opacity: { duration: 0.8 } 
            }
        },
        exit: (direction) => ({
            x: direction < 0 ? 100 : -100,
            opacity: 0,
            transition: {
                x: { type: "spring", stiffness: 100, damping: 20 }, 
                opacity: { duration: 0.5 } 
            }
        })
    };

    return (
        <section className="reviews-section section pt-5">
            <h1 className='review mt-5'>REVIEWS</h1>
            <h2 className='kind-words mt-5'>Kind Words From Our Customers</h2>

            <div className="review-wrapper mt-5">
                <motion.div className="review-container"
                    custom={-1}
                    variants={reviewVariants}
                    initial="hidden"
                    whileInView="visible"
                    exit="exit">
                    <p className="review-text">It’s just incredible</p>
                    <p className="review-text">I have been a client of Connekt for several years. They provide an excellent service at an amazingly great price. I tell my friends about this great service.</p>
                    <hr />
                    <div className='user-review'>
                        <img className="customer-image" src={'../images/avata.png'} alt="Customer" />
                        <div className='user-info'>
                            <span className='user-name'>Ginika</span> <br />
                            <span className='from'>Spurhub</span>
                        </div>
                    </div>
                </motion.div>

                <motion.div className="review-container"
                    custom={1}
                    variants={reviewVariants}
                    initial="hidden"
                    whileInView="visible"
                    exit="exit">
                    <p className="review-text">Satisfied Customer Here!</p>
                    <p className="review-text" style={{marginBottom:"37px"}}>I have had their service for over 1 year, completely trouble-free. Installers were a pleasure to deal with.</p>
                    <hr />
                    <div className='user-review'>
                        <img className="customer-image" src={'../images/avata.png'} alt="Customer" />
                        <div className='user-info'>
                            <span className='user-name'>Nonso</span> <br />
                            <span className='from'>HOUSE OWNER</span>
                        </div>
                    </div>
                </motion.div>

                <motion.div className="review-container"
                    custom={-1}
                    variants={reviewVariants}
                    initial="hidden"
                    whileInView="visible"
                    exit="exit">
                    <p className="review-text">No doubt, Connekt is the best!</p>
                    <p className="review-text">We had a bad service for ages and were completely unhappy with it. We switched to Connekt and have never looked back. We are much happier.</p>
                    <hr />
                    <div className='user-review'>
                        <img className="customer-image" src={'../images/avata.png'} alt="Customer" />
                        <div className='user-info'>
                            <span className='user-name'>Praise</span> <br />
                            <span className='from'>234 Finance</span>
                        </div>
                    </div>
                </motion.div>
            </div>

            <div className='rotate-icons'>
                <img src="../images/Button Prev.png" alt="Previous" />
                <img src="../images/Button Next.png" alt="Next" />
            </div>
        </section>
    );
};

export default Reviews;
